import { SanitizeHTML } from '../../../globals/SanitizeHTML';

export const FieldDescription = ({ description }) => {
  return description ? (
    <p className="field-description text-xs text-black opacity-60 px-0 pb-2">
      <SanitizeHTML html={description.replaceAll('\n', '<br/>')} />
    </p>
  ) : (
    <></>
  );
};
